import { render, staticRenderFns } from "./ManageOfficial.vue?vue&type=template&id=e0a59b7a&"
import script from "./ManageOfficial.vue?vue&type=script&lang=js&"
export * from "./ManageOfficial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports